import styled from "styled-components";
import { avatarStyle } from "../Avatar/Avatar.styled";

export const AvatarsCollection = styled.ul`
  display: flex;
  align-items: center;
  transform: scale(1);
  transition: transform 0.2s cubic-bezier(0, 0, 0.25, 1);
  cursor: pointer;

  :hover {
    transform: scale(1.02);
  }

  li {
    flex: 0 0 auto;
    margin-left: -10px;
  }
`;

export const Count = styled.li`
  ${avatarStyle};

  display: flex;
  align-items: center;
  justify-content: center;
`;
